import Chip from '@mui/material/Chip'
import styled from '@mui/system/styled'

export const StyledChip = styled(Chip)(({ theme }) => ({
  height: 22,
  span: { padding: 0 },
  '& .MuiChip-label': { padding: `1px ${theme.spacing(1)}` },
}))
